import React from 'react';
import moment from 'moment';
import styled from 'styled-components';
import {Link} from 'react-router-dom';
import {ProspectActivity, UnsubscribeMailCampaignProspectActivity} from 'api';

interface UnsubscribeActivity extends ProspectActivity {
  resource: UnsubscribeMailCampaignProspectActivity;
}

interface Props {
  prospectActivity: UnsubscribeActivity;
}

export default ({prospectActivity}: Props) => {
  const {createdAt} = prospectActivity;

  return (
    <>
      <Icon />
      <Content>
        <span>
          <Link
            target="_blank"
            to={`/pools/${prospectActivity.resource.mailCampaignSend.mailCampaign.pool.uuid}/mail_campaigns/${prospectActivity.resource.mailCampaignSend.mailCampaign.uuid}`}>
            配信停止
          </Link>
        </span>
        <time>{moment(createdAt).format('YYYY/MM/DD HH:mm')}</time>
      </Content>
    </>
  );
};

const Content = styled.div`
  display: flex;
  flex: 1;
  margin-top: -4px;
  margin-left: 3px;

  span:first-child {
    flex: 1;
    margin: 0;
    color: var(--text-color-1);
    font-weight: 500;
  }

  span,
  time {
    color: var(--text-color-2);
    margin-left: 15px;
  }
`;

const Icon = styled.span`
  height: 10px;
  width: 10px;
  background: #c4c4c4;
  border-radius: 50%;
  margin-left: 10px;
  margin-right: 15px;
  z-index: 1;
`;
